<template>
  <div v-if="deals.length > 1" class="top-pick">
    <div class="top-picks-for-you">
      <div class="trophy">
        <img
          src="~/static/trophy.svg"
          alt=""
        >
      </div>
      <h5 class="mobile-header">
        Our top pick for you
      </h5>
      <h5 class="desktop-header">
        Top picks for you
      </h5>
      <p>We thought you might like this.<br>See what we recommend for you.</p>
      <NuxtLink :to="more">
        Explore more
      </NuxtLink>
    </div>
    <deal-impression
      v-for="deal in deals.slice(0, 2)"
      :id="deal.id"
      :key="deal.id"
    >
      <div class="pick">
        <div class="image-container">
          <NuxtLink
            class="d-block"
            :to="deal.get_absolute_url"
          >
            <VLazyImage
              class="product-image"
              :src="`${deal.media_url}?width=450&height=300&aspect_ratio=3:2`"
              :src-placeholder="lazyPlaceholderImage"
            />
          </NuxtLink>
        </div>
        <h4>{{ deal.public_name }}</h4>
        <p class="top-pick-deal-description">
          {{ generateCardDescription(deal) }}
        </p>
        <taco-rating
          :class="['sumo-taco-rating', 'featured-deal-taco-container']"
          :deal="deal"
          :browse="true"
        />
        <deal-price
          class="top-pick-component"
          :price="deal.price"
          :original-price="deal.original_price"
          :is-free="deal.is_free"
        />
        <div class="buy">
          <NuxtLink :to="deal.get_absolute_url">
            Buy Now
          </NuxtLink>
        </div>
      </div>
    </deal-impression>
  </div>
</template>
<script>
import get from 'lodash/get';
import VLazyImage from 'v-lazy-image';
import { DEAL_PLACEHOLDER_IMG } from '@/constants/global';
import DealImpression from './DealImpression.vue';
import TacoRating from '../utilities/TacoRating.vue';
import DealPrice from './DealPrice.vue';

export default {
  components: {
    VLazyImage,
    DealImpression,
    TacoRating,
    DealPrice,
  },
  props: {
    deals: {
      type: Array,
      required: true,
    },
    more: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lazyPlaceholderImage: DEAL_PLACEHOLDER_IMG,
    };
  },
  methods: {
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~/styles/utils/breakpoints';

.top-pick-deal-description {
  overflow: hidden;
  text-overflow: ellipsis;

  /* stylelint-disable-next-line */
  display: -webkit-box !important;
  -webkit-line-clamp: 3;

  /* stylelint-disable-next-line */
  -webkit-box-orient: vertical;
  max-height: 63px;
}

.top-pick {
  background: radial-gradient(58.66% 71.5% at 64.93% 27.87%, #265e60 24.72%, #09292b 100%);
  margin-left: -30px;
  margin-right: -30px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: row;
  padding: 64px;
}

.top-pick .top-picks-for-you {
  flex: 1 0 350px;
}

.top-pick .sumo-taco-rating {
  margin-bottom: 10px;
}

.top-pick .top-picks-for-you .mobile-header {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #fff;
  margin: 16px 0;
  display: none;
}

.top-pick .top-picks-for-you .desktop-header {
  font-weight: 600;
  font-size: 28px;
  line-height: 42px;
  color: #fff;
  margin: 16px 0;
}

.top-pick .top-picks-for-you p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  margin: 0 0 40px;
}

.top-pick .top-picks-for-you a {
  background: #ffbc00;
  border-radius: 40px;
  color: #1b1b1b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 16px 40px;
  text-decoration: none;
}

.top-pick .pick {
  padding: 0 16px;
  flex: 1 1 0;
}

.top-pick .pick .image-container {
  background: #fff;
  border-radius: 4px;
  width: 320px;
}

.top-pick .pick img {
  border-radius: 4px;
  width: 100%;
}

.top-pick .pick h4 {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #fff;
  margin-top: 12px;
  max-width: 320px;
}

.top-pick .pick p {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #fff;
  max-width: 320px;
}

.top-pick .pick .buy {
  display: none;
}

.top-pick .trophy {
  width: 56px;
  height: 56px;
  background: #09292b;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.top-pick .trophy img {
  width: 50px;
  height: 50px;
}

@include media-breakpoint-down(lg) {
  .top-pick .pick:last-child {
    display: none;
  }
}

@include media-breakpoint-down(sm) {
  .top-pick .sumo-taco-rating {
    justify-content: center;
  }

  .top-pick .top-picks-for-you .mobile-header {
    display: block;
  }

  .top-pick .top-picks-for-you .desktop-header {
    display: none;
  }

  .top-pick {
    flex-direction: column;
    padding: 48px 32px;
    margin-left: -20px;
    margin-right: -20px;
    flex-basis: auto;
  }

  .top-pick .top-picks-for-you {
    margin-top: -50px;
    flex-basis: auto;
  }

  .top-pick .top-picks-for-you .trophy {
    margin: 0 auto;
    top: -16px;
    position: relative;
  }

  .top-pick .top-picks-for-you h5 {
    text-align: center;
    margin: 0 0 16px;
  }

  .top-pick .top-picks-for-you p {
    display: none;
  }

  .top-pick .top-picks-for-you a {
    display: none;
  }

  .top-pick .pick {
    margin: 0 auto;
    max-width: 420px;
    text-align: center;
  }

  .top-pick .pick h4 {
    text-align: center;
    max-width: 100%;
  }

  .top-pick .pick p {
    text-align: center;
    max-width: 100%;
  }

  .top-pick .pick .image-container {
    width: 100%;
  }

  .top-pick .pick .image-container img {
    width: 100%;
  }

  .top-pick .pick .buy {
    display: block;
    text-align: center;
    padding: 16px 0 0;
  }

  .top-pick .pick .buy a {
    background: #ffbc00;
    border-radius: 40px;
    color: #1b1b1b;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    padding: 16px 40px;
    text-decoration: none;
  }

  .top-pick .pick .price {
    text-align: center;
  }
}
</style>
